import { useSurfaceTreatmentSelect } from "#modules/quoteRequestLinesV2/hooks/useSurfaceTreatmentSelect";
import { MultiSelectInputController } from "#shared/view/designSystem/inputs/MultiSelectInputController";

export const NO_SURFACE_TREATMENT_KEY = "NO_SURFACE_TREATMENT";

type Props = {
  quoteRequestLineIds: string[];
  disabled?: boolean;
  size?: "sm" | "md";
  label?: string;
  placeholder?: string;
};

export const SurfaceTreatmentSelect = ({
  quoteRequestLineIds,
  disabled = false,
  size,
  label,
  placeholder,
}: Props) => {
  const { data, value, onChange, hasOptions } = useSurfaceTreatmentSelect(quoteRequestLineIds);

  if (!hasOptions) {
    return null;
  }

  return (
    <MultiSelectInputController
      name="surfaceTreatmentKeys"
      label={label}
      placeholder={placeholder}
      data={data}
      value={value}
      onChange={onChange}
      disabled={disabled}
      size={size}
      clearable
      searchable
    />
  );
};
